<template>
  <div class="row pb-5 accordion-element">
    <div class="col">
      <Accordion>
        <AccordionTab> <!-- header="Informations supplémentaires">-->
          <template #header>
            <td>Informations supplémentaires</td>
            <vue-loaders v-if="isDataLoading == true" name="ball-beat"></vue-loaders>
          </template>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Référence nom :</label>
                </div>
                <div class="col text-left txt">
                  <p v-if="!nomReference"> ... </p>
                  <p v-else> {{ nomReference }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>NEQ :</label>
                </div>
                <div class="col txt">
                  <p v-if="!numeroEntrepriseQuebec"> ... </p>
                  <p v-else> {{ numeroEntrepriseQuebec }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Site d'origine :</label>
                </div>
                <div class="col txt">
                  <p v-if="!siteAfficher"> ... </p>
                  <p v-else> {{ siteAfficher }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Référence prénom :</label>
                </div>
                <div class="col txt">
                  <p v-if="!prenomReference"> ... </p>
                  <p v-else> {{ prenomReference }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Référence :</label>
                </div>
                <div class="col txt">
                  <p v-if="!reference"> ... </p>
                  <p v-else> {{ reference }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Date de création :</label>
                </div>
                <div class="col txt">
                  <p v-if="!$commun.formatDateHeure(creerLe)"> ... </p>
                  <p v-else> {{ $commun.formatDateHeure(creerLe) }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Région :</label>
                </div>
                <div class="col txt">
                  <p v-if="!region"> ... </p>
                  <p v-else> {{ region }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Confidentialité :</label>
                </div>
                <div class="col txt">
                  <p v-if="!confidentialiteAfficher"> ... </p>
                  <p v-else> {{ confidentialiteAfficher }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Créé par :</label>
                </div>
                <div class="col txt">
                  <p v-if="!creerParDescription"> ... </p>
                  <p v-else> {{ creerParDescription }} </p>
                </div>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
      <Accordion v-if="indicateurRDD">
        <AccordionTab>
          <template #header>
            <td>Informations RDD</td>
            <vue-loaders v-if="isDataLoading == true" name="ball-beat"></vue-loaders>
          </template>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col-7 lbl">
                  <label>Centre régional :</label>
                </div>
                <div class="col-5 txt">
                  <p v-if="!centreRegionalRDD"> ... </p>
                  <p v-else> {{ centreRegionalRDD }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl">
                  <label>Code du compte :</label>
                </div>
                <div class="col-5 txt">
                  <p v-if="!codeCompteRDD"> ... </p>
                  <p v-else> {{ codeCompteRDD }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col-7 lbl">
                  <label> Raison de la désactivation : </label>
                </div>
                <div class="col-5 txt">
                  <p v-if="!raisonDesactivationRDD"> ... </p>
                  <p v-else> {{ raisonDesactivationRDD }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Territoire :</label>
                </div>
                <div class="col txt">
                  <p v-if="!territoireRDD"> ... </p>
                  <p v-else> {{ territoireRDD }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label> Statut d'exclusion : </label>
                </div>
                <div class="col txt">
                  <p v-if="!statutExclusionRDD"> ... </p>
                  <p v-else> {{ statutExclusionRDD }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label> Date fin d'opération : </label>
                </div>
                <div class="col txt">
                  <p v-if="!$commun.formatDate(dateDesactivationRDD)"> ... </p>
                  <p v-else> {{ $commun.formatDate(dateDesactivationRDD) }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label> Actif : </label>
                </div>
                <div class="col txt">
                  <p v-if="!actifRDD"> ... </p>
                  <p v-else> {{ actifRDD }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label> Date de désactivation : </label>
                </div>
                <div class="col txt">
                  <p v-if="!$commun.formatDate(dateFinRDD)"> ... </p>
                  <p v-else> {{ $commun.formatDate(dateFinRDD) }} </p>
                </div>
              </div>
              <div class="row"></div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InformationSupplementaire',
  props: ['isDataLoading', 'nomReference', 'numeroEntrepriseQuebec', 'siteAfficher', 
          'prenomReference', 'reference', 'creerLe', 'region', 'confidentialiteAfficher',
          'creerParDescription', 'centreRegionalRDD', 'codeCompteRDD', 'indicateurRDD',
          'raisonDesactivationRDD', 'territoireRDD', 'statutExclusionRDD', 'dateDesactivationRDD',
          'actifRDD', 'dateFinRDD'],
}
</script>